import { Navigate, Outlet, useLocation } from "react-router";

import { LandingPage } from "src/app/pages/LandingPage/LandingPage";
import { getAccessToken } from "../../core/router/auth";
import { RedirectProvider } from "../../core/router/auth/RedirectProvider";
import { ProtectedRoute } from "../../core/router/components/ProtectedRoute/ProtectedRoute";
import { msalInstance } from "../../core/router/config/msalConfig";
import { routes } from "../../core/router/config/routes";
import { BASE_PATH } from "../../core/router/types/routerTypes";
import { ChooseDataGroupModal, NoDataGroupModal } from "../index";
import { NotificationRouteListener } from "../NotificationAlerts";
import { NotificationAlertManager } from "../NotificationAlerts/NotificationAlertManager";
import { Content } from "./components/Content";
import { Header } from "./components/Header";
import { MasterLayout } from "./components/MasterLayout";
import { SideBar } from "./components/SideBar";

export const AppLayout = () => {
    const location = useLocation();
    const token = getAccessToken();
    const activeAccount = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

    if (!token && !activeAccount) {
        return <Navigate to={routes.login.path} replace />;
    }

    return (
        <ProtectedRoute>
            <MasterLayout>
                <RedirectProvider />
                <NotificationRouteListener />
                <Header />
                <SideBar />
                <Content id="pageContent">
                    <NotificationAlertManager />
                    {location.pathname === `${BASE_PATH}/` || location.pathname === BASE_PATH ? <LandingPage /> : <Outlet />}
                </Content>
                <ChooseDataGroupModal />
                <NoDataGroupModal />
            </MasterLayout>
        </ProtectedRoute>
    );
};
